// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_WXb","cls2":"DebugPage-cls2_Afn DebugPage-cls1_WXb"};